import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowAdsInfo from '../components/advertisesAndInformations/ShowAdsInfo'

const AdsInfos:React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Publicités et informations")}</h1>
      <ShowAdsInfo />
    </div>
  )
}

export default AdsInfos
